import { VanillaDateRange } from '@/data/vanilla-date-range';

export default function ListColumn (column) {
    if (column == null) {
        column = {};
    }

    column.aggregation = function (entity, fact) {
        return Object.assign(column, {
            kind: entity,
            schema: 'aggregation',
            fact,
            type: `${entity}.${fact}`,
            id: `${entity}_${fact}`,
        });
    };

    ['account', 'parentAccount', 'visitor'].forEach((entity) => {
        column[entity] = function (fact) {
            return column.aggregation(entity, fact);
        };
    });

    column.tag = function (entity, tagId) {
        column[`${entity}Id`] = tagId;

        return column;
    };

    column.setAppId = function (appIds) {
        column.appIds = appIds;

        return column;
    };

    ['page', 'feature', 'trackType'].forEach((entity) => {
        column[entity] = function (tagId) {
            return column.tag(entity, tagId);
        };
    });

    ['trailing', 'withinLast'].forEach((time) => {
        column[time] = function (count, granularity) {
            return Object.assign(column, {
                time,
                granularity: granularity || 'days',
                count,
            });
        };
    });

    column.makeImmutable = function () {
        column.immutable = true;

        return column;
    };

    column.getTimeSeries = function (relativeToDateRange) {
        if (!relativeToDateRange) {
            relativeToDateRange = { type: 'Yesterday' };
        }

        const vanillaDateRange = new VanillaDateRange(relativeToDateRange);

        if (column.time === 'between') {
            return {
                period: 'dayRange',
                first: `${column.first}`,
                last: `${column.last}`,
            };
        }
        if (column.time === 'withinLast') {
            return {
                period: 'dayRange',
                first: `dateAdd(now(),-${column.count},"${column.granularity}")`,
                last: `dateAdd(now(),-${column.count > 0 ? 1 : 0},"days")`,
            };
        }
        if (column.time === 'trailing') {
            // Align to the end of the given time range (defaults to "Yesterday", i.e. same behavior as "withinLast")
            const timeSeriesType = vanillaDateRange.type;
            if (timeSeriesType === 'Custom') {
                const relativeToTimeSeries = vanillaDateRange.timeSeries();
                const last = relativeToTimeSeries.last();

                return {
                    period: 'dayRange',
                    first: `dateAdd(${last},-${column.count},"${column.granularity}")`,
                    count: column.count,
                };
            }
            if (timeSeriesType === 'Today' || /^\d+/.test(timeSeriesType)) {
                return {
                    period: 'dayRange',
                    first: `dateAdd(startOfPeriod("daily",now()),-${Math.max(0, column.count - 1)},"${
                        column.granularity
                    }")`,
                    last: 'startOfPeriod("daily",now())',
                };
            }

            return {
                period: 'dayRange',
                first: `dateAdd(startOfPeriod("daily",now()),-${column.count},"${column.granularity}")`,
                last: `dateAdd(startOfPeriod("daily",now()),-${column.count > 0 ? 1 : 0},"days")`,
            };
        }

        return vanillaDateRange.relativeTimeSeries();
    };

    return column;
}
